module.exports = __webpack_public_path__ + "img/cbr-pc-play.49a55d14.svg";